import { radioClasses } from "@mui/material/Radio";
export const FormControlLabel = {
    MuiFormControlLabel: {
        variants: [
            {
                props: {
                    variant: "filled"
                },
                style: ({ theme })=>({
                        backgroundColor: theme.palette.grey[100],
                        borderRadius: Number(theme.shape.borderRadius) * 3,
                        padding: theme.spacing(1, 0),
                        paddingRight: theme.spacing(2),
                        border: `1px solid ${theme.palette.grey[300]}`,
                        [`&:has(.${radioClasses.checked})`]: {
                            border: `1px solid ${theme.palette.primary.light}`,
                            backgroundColor: theme.palette.action.selected
                        }
                    })
            }
        ]
    }
};

//# sourceMappingURL=FormControlLabel.js.map